module.exports = new __parcel__URL__("logo.5823b0b1.svg").toString();